import React from "react";
import { IconExclamationMark } from "@tabler/icons-react";

import ViewTitle from "./ViewTitle";

export default function ViewError(props) {
  return <ViewTitle icon={<IconExclamationMark size={100} />} {...props} />;
}
